export default {
  cargoType: {
    GENERAL: 'General Cargo',
    DGR: 'Dangerous Goods',
    DANGEROUS: 'Dangerous Goods',
    PERISHABLE: 'Perishable',
    COLD_CHAIN: 'Cold Chain',
    OVERSIZE: 'Oversize',
    OVERSIZED: 'Oversized Cargo',
    BATTERY: 'Battery',
    PHARMA: 'Pharmaceutical',
    ECOMMERCE: 'E-commerce',
    LIVE_ANIMAL: 'Live Animal',
    VALUABLE: 'Valuable',
    SMART: 'Valuable',
    WET: 'Wet Cargo',
  },
  uldType: {
    PMC: 'PMC Standard Pallet',
    PAG: 'PAG High Pallet',
    AKE: 'AKE Container',
    PGE: 'PGE Half Pallet',
    BULK: 'BULK Hold',
    RKN: 'RKN Refrigerated Container',
    PIV: 'PIV Dangerous Goods Container',
  },
  contractType: {
    LONG_TERM: 'Long-term Agreement',
    TEMP: 'Temporary Order',
  },
  customerLevel: {
    VIP: 'VIP',
    NORMAL: 'Normal',
    STRATEGIC: 'Strategic Partner',
  },
  paymentTerms: {
    PREPAID: 'Prepaid',
    COLLECT: 'Collect',
    MONTHLY: 'Monthly Settlement',
  },
  productType: {
    OWN: 'Own Product',
    OUTSOURCE: 'Outsource',
    AIRLINE_SOURCE: 'Airline Source',
    AIRLINE_BOOKING: 'Airline Booking',
  },
  customerSource: {
    SALES: 'Sales Customer',
    ROUTE: 'Route Customer',
    COMPANY: 'Company Customer',
    INTERNAL: 'Internal Customer',
  },
  transportMode: {
    DIRECT: 'Direct',
    TRANSIT: 'Transit',
    TRANSFER: 'Transfer',
    AIR_TO_LAND: 'Air to Land',
    MULTIMODAL: 'Multimodal',
  },
  legalEntityRelation: {
    SAME: 'Same Legal Entity',
    DIFF: 'Different Legal Entity',
  },
  region: {
    ASIA_PACIFIC: 'Asia Pacific',
    APAC: 'Asia Pacific',
    AMERICAS: 'Americas',
    EUROPE: 'Europe',
    MIDDLE_EAST: 'Middle East',
    INDIA: 'India',
    AFRICA: 'Africa',
  },
  profitRole: {
    ROUTE: 'Route',
    SALES: 'Sales',
    GROUP_INTERNAL: 'Group Internal',
    FIRST_LEVEL: 'First-level',
    INTERNAL: 'Group Internal',
    FIRST: 'First-level',
  },
  temperature: {
    NORMAL: 'Normal',
    COLD_2_8: '2-8°C',
    FROZEN_20: '-20°C',
  },
  stackDirection: {
    UP: 'Up',
    ANY: 'Any',
  },
  tradeType: {
    GENERAL_TRADE: 'General Trade',
    EXPRESS: 'Express',
    OTHER: 'Other',
  },
  freightMode: {
    AIR_DIRECT: 'Air Direct',
    AIR_TO_LAND: 'Air-to-Land',
    MULTIMODAL: 'Multimodal',
  },
  costType: {
    ESTIMATED: 'Estimated',
    ACTUAL: 'Actual',
  },
  feeType: {
    HANDLING: 'Handling',
    STORAGE: 'Storage',
    CUSTOMS: 'Customs',
    TRANSPORT: 'Transport',
    SECURITY: 'Security',
    TERMINAL: 'Terminal',
    DOCUMENT: 'Document',
    OTHER: 'Other',
  },
  dissolveReason: {
    FLIGHT_CANCELLED: 'Flight Cancelled',
    INSUFFICIENT_SPACE: 'Insufficient Space',
    CUSTOMER_REQUEST: 'Customer Request',
    OTHER: 'Other',
  },
  bizOrderViewStatus: {
    UNVIEWED: 'Route Unviewed',
    VIEWED: 'Route Viewed',
  },
  taxFlag: {
    TAXABLE: 'Taxable',
    DUTY_FREE: 'Duty Free',
  },
  serviceItem: {
    BOOKING: 'Booking Service',
    GROUND: 'Ground Service',
    MANIFEST: 'Manifest Service',
  },
  paymentMethod: {
    PREPAID: 'Prepaid',
    COLLECT: 'Collect',
  },
  warehouseStatus: {
    PENDING: 'Pending Warehouse Data',
    ENTERED: 'Actual Data Confirmed',
  },
  dateFilter: {
    ALL: 'All',
    TODAY: 'Today',
    DAYS3: 'Next 3 Days',
    WEEK: 'Next Week',
  },
  weightFilter: {
    ALL: 'All',
    LT50: '<50KG',
    RANGE_50_100: '50-100KG',
    RANGE_100_300: '100-300KG',
    GT300: '>300KG',
  },
  cargoFilter: {
    GENERAL: 'General Cargo',
    NON_GENERAL: 'Non-general Cargo',
    ALL: 'All',
    DANGER: 'Dangerous Goods',
    TEMP: 'Temperature Controlled',
    OVERSIZE: 'Oversize',
  },
  groupBy: {
    ROUTE: 'Group by Route',
    ETD: 'Group by ETD',
    DESTINATION: 'Group by Destination',
    CUSTOMER: 'Group by Customer',
  },
  bubbleShare: {
    NONE: 'No (charge at original unit price)',
    RATIO_2_8: '2/8 bubble share (80% bubble weight concession)',
    RATIO_3_7: '3/7 bubble share (70% bubble weight concession)',
    RATIO_5_5: '5/5 bubble share (50/50 split)',
    CUSTOM: 'Custom',
  },
  bubbleRatio: {
    ACTUAL: 'Actual Bubble Ratio',
    RATIO_167: '1:167 (Standard)',
    RATIO_130: '1:130',
    RATIO_120: '1:120',
    RATIO_100: '1:100',
    CUSTOM: 'Custom',
  },
  bubbleDisplayMode: {
    RATE: 'By Rate',
    WEIGHT: 'By Charge Wt',
  },
  loginResult: {
    SUCCESS: 'Success',
    FAIL: 'Failed',
  },
  customerStatus: {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
  },
  userStatus: {
    ACTIVE: 'Enabled',
    INACTIVE: 'Disabled',
  },
  agreementStatus: {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
  },
  agreementPeriodStatus: {
    ONGOING: 'Ongoing',
    ENDED: 'Ended',
  },
  agreementType: {
    BSA: 'BSA Pallet',
    VOLUME: 'Volume',
  },
  cycleType: {
    SINGLE: 'Single Cycle',
    WEEKLY: 'Weekly Cycle',
    BIWEEKLY: 'Two-week Cycle',
    SEMIMONTHLY: 'Half-month Cycle',
    MONTHLY_WEEK: 'Monthly-week Cycle',
    MONTHLY: 'Monthly Cycle',
  },
  occupationStatus: {
    OCCUPIED: 'Occupied',
    AVAILABLE: 'Available',
  },
  weekDay: {
    MON: 'Mon',
    TUE: 'Tue',
    WED: 'Wed',
    THU: 'Thu',
    FRI: 'Fri',
    SAT: 'Sat',
    SUN: 'Sun',
  },
  nullOption: {
    NO_AGREEMENT: '— No Agreement —',
  },
  currency: {
    CNY: 'CNY Chinese Yuan',
    USD: 'USD US Dollar',
    HKD: 'HKD Hong Kong Dollar',
  },
  notifyType: {
    TASK: 'Task',
    WARNING: 'Warning',
    MILESTONE: 'Milestone',
    INFO: 'Info',
    URGENT: 'Urgent',
  },
  quickFilter: {
    thisMonthCompleted: 'This Month Completed',
    lastMonthCompleted: 'Last Month Completed',
    thisQuarter: 'This Quarter',
    lossRoute: 'Loss-making Routes',
  },
  unit: {
    piece: 'pcs',
    ticket: 'shipment | shipments',
    minute: 'min',
    ton: 't',
  },
  permissionType: {
    MENU: 'Menu',
    BUTTON: 'Button',
    API: 'API',
  },
  dataScope: {
    ALL: 'All Data',
    SELF: 'Self Only',
    DEPT: 'Department',
    DEPT_AND_CHILD: 'Dept & Sub-depts',
  },
  dataScopeDesc: {
    ALL: 'Can view all data',
    SELF: 'Can only view own data',
    DEPT: 'Can view all data in the department',
    DEPT_AND_CHILD: 'Can view data in department and sub-departments',
  },
  daySuffix: '',
  // entry/dialogs types
  urgency: {
    URGENT: 'Urgent',
    NORMAL: 'Normal',
  },
  cargoDensity: {
    HEAVY: 'Heavy Cargo',
    LIGHT: 'Volumetric Cargo',
    NORMAL: 'Balanced Cargo',
  },
  diffHandling: {
    AMEND: 'Amendment',
    ABSORB: 'Absorb',
    DISPUTE: 'Dispute',
  },
  // entry/components/CenterPanel/MasterOrderItem/HawbCard types
  diffHandlingShort: {
    AMEND: 'Amend',
    ABSORB: 'Absorb',
    DISPUTE: 'Dispute',
  },
  dataSource: {
    ESTIMATED: 'Estimated Data',
    CONFIRMED: 'Confirmed Data',
    ADJUSTED: 'Adjusted Data',
  },
  // cs-workbench/components/CenterPanel/BizOrderForm/WarehouseDataSection types
  chargeWeightRule: {
    ROUND: 'Round half up (2 decimals)',
    HALF_KG_UP: 'Round up to next 0.5 kg (IATA standard)',
  },
  warehouseDataStatus: {
    PENDING: 'Not Required',
    REQUIRED: 'Pending Backfill',
    ENTERED: 'Backfilled',
    ADJUSTED: 'Adjusted',
  },
  warehouseDataSource: {
    OPS: 'Route Pre-fill',
    CS: 'CS Backfill',
  },
}
